module.exports = __webpack_public_path__ + "static/media/header_text_1.d171883a.png";